import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { NAV } from "../data/site";
import { Menu, X, MessageSquareText } from "lucide-react";
import { waLink, WA_DISPLAY } from "../lib/whatsapp";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled ? "bg-white/90 backdrop-blur-xl shadow-[0_1px_0_rgba(11,31,58,0.06)]" : "bg-white/80 backdrop-blur-md"
      }`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 lg:px-12 h-20">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3">
          <span className="w-8 h-8 rounded-full border border-[#C8A96A] flex items-center justify-center">
            <span className="w-2 h-2 rounded-full bg-[#C8A96A]" />
          </span>
          <span className="font-serif text-[22px] tracking-tight text-[#0B1F3A]">
            Easy<span className="text-[#C8A96A]">ilaaz</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `link-elegant text-[13px] tracking-wide ${isActive ? "text-[#C8A96A]" : "text-[#0B1F3A]/80 hover:text-[#0B1F3A]"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp"
            className="inline-flex items-center gap-2 text-[12px] tracking-wide text-[#0B1F3A]/70 hover:text-[#C8A96A] transition-colors duration-300"
            title={`WhatsApp ${WA_DISPLAY}`}
          >
            <MessageSquareText size={16} strokeWidth={1.25} /> WhatsApp
          </a>
          <Link
            to="/contact"
            data-testid="nav-cta-consultation"
            className="inline-flex items-center px-6 h-11 rounded-full bg-[#0B1F3A] text-white text-[12px] tracking-[0.16em] uppercase hover:bg-[#C8A96A] transition-colors duration-300"
          >
            Request Consultation
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-[#0B1F3A]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X strokeWidth={1.25} /> : <Menu strokeWidth={1.25} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-[#E6E9EF]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-[15px] text-[#0B1F3A]"
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-nav-cta"
              className="mt-2 inline-flex justify-center items-center h-11 rounded-full bg-[#0B1F3A] text-white text-[12px] tracking-[0.16em] uppercase"
            >
              Request Consultation
            </Link>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-nav-whatsapp"
              className="inline-flex justify-center items-center gap-2 h-11 rounded-full border border-[#0B1F3A] text-[#0B1F3A] text-[12px] tracking-[0.16em] uppercase"
            >
              <MessageSquareText size={16} strokeWidth={1.25} /> WhatsApp Concierge
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
